import { FacetTreeLevel, TempCustomFacetValue } from '@catalog/const';

export class Level {
  name?: string;
  children: FacetTreeLevel['children'];
  query?: FacetTreeLevel['query'];
  id: string;

  constructor(data: TempCustomFacetValue) {
    if (data.categoryPathArray.length === 1) {
      this.name = data.name;
      this.id = data.categoryPathArray[0];
      this.query = data.query;
      this.children = [];
    } else {
      this.name = undefined;
      this.id = data.categoryPathArray[0];
      this.query = data.query;
      const nextCategoryPathArray = data.categoryPathArray.slice(1);
      this.children = [new Level({ ...data, categoryPathArray: nextCategoryPathArray })];
    }
  }
}
